import createReducer from "../utils/createReducer";
import businessModelActions from '../actions/businessModel';
import {getComponentState} from '../utils/localStorageDataHandler';
import {checkBusinessModelBtnStatus} from '../utils/validate';

const initialState = {};

const actionHandlers = {
    [businessModelActions.SET_BUSINESS_MODEL_CHOICE](state, {payload}) {
        return {
            ...state,
            businessModelChoice: payload.businessModelChoice
        };
    },

    [businessModelActions.GET_ADVERTISER_BUSINESS_MODEL_SUCCESS](state, {payload}) {
        return {
            ...state,
            advertiserBusinessModel: payload.advertiserBusinessModel,
            serviceError: false
        };
    },

    [businessModelActions.BUSINESS_MODEL_SERVICE_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey
        };
    },

    [businessModelActions.TOGGLE_BUSINESS_MODEL_CONTINUE_BUTTON](state, {}) {
        const enableBusinessModelContinueBtn = checkBusinessModelBtnStatus(state);
        return {
            ...state,
            enableBusinessModelContinueBtn
        };
    },

    [businessModelActions.PRE_POPULATE_LOCAL_STATE_BUSINESS_MODEL](state, {payload}) {
        const stateData = getComponentState(payload.publicUuid, 'businessModel');

        if (stateData && stateData.state) {
            state = stateData.state;
        }

        return {
            ...state,
            enableBusinessModelContinueBtn: false
        };
    },

    [businessModelActions.SUBMIT_BUSINESS_MODEL_SUCCESS](state, {}) {
        return {
            ...state,
            serviceError: false
        };
    }
};

export default createReducer(actionHandlers, initialState);